import { render } from "./DeviceFilesIndex.vue?vue&type=template&id=0aed0304"
import script from "./DeviceFilesIndex.vue?vue&type=script&lang=js"
export * from "./DeviceFilesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__